import { LoginModel } from "@/models/login/LoginModel";
import { authApi } from "@/api/AuthApi";
import { LoginResponseDTO } from "@/api/auth/LoginResponseDTO";
import { AlterarSenhaModel } from '@/models/login/AlterarSenhaModel';
import { AtualizarTokenModel } from '@/models/login/AtualizarTokenModel';

class UsuarioService {
  efetuarLogin(loginModel: LoginModel): Promise<LoginResponseDTO> {
    return authApi.efetuarlogin({
      username: loginModel.username,
      password: loginModel.password,
      grant_type: "password",
    });
  }
  
  atualizarToken(atualizarToken: AtualizarTokenModel): Promise<LoginResponseDTO> {
    return authApi.atualizarToken({
      refresh_token: atualizarToken.refreshToken,
      grant_type: "refresh_token",
    });
  }

  solicitarResetSenha(email: string) {
    return authApi.solicitarResetSenha({usuario: email});
  }

  resetarSenha(token: string, novaSenha: string) {
    return authApi.resetarSenha(token, novaSenha);
  }

  alterarSenha(usuario: string, senha: AlterarSenhaModel)  {
    return authApi.alterarSenha({
      usuario,
      senhaAtual: senha.senhaAtual,
      novaSenha: senha.senhaNova,
      confirmacaoNovaSenha: senha.confirmacaoSenhaNova,
    });
  }
}

export const usuarioService = new UsuarioService();
